export interface ApplicationStatusKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the application status/phase read. The
 * shape mirrors `dscWorkbenchKeys` so cache invalidation stays predictable:
 * invalidating `all` flushes every status query, `details()` flushes all status
 * reads, and `detail({ approvalId })` flushes a single deal's status. Never
 * write a literal key array outside this module — the factory IS the schema.
 *
 * Keyed on approvalId alone: the BFF endpoint is
 * `/api/v1/workbench/applications/{approvalId}/status` — no dealer in the path.
 */
export const applicationStatusKeys = {
  all: ["applicationStatus"] as const,
  details: () => [...applicationStatusKeys.all, "detail"] as const,
  detail: (arguments_: ApplicationStatusKeyArguments) => [...applicationStatusKeys.details(), arguments_] as const,
};
